module.exports = __webpack_public_path__ + "img/snipers_2.b69d6cb.jpg";